import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function About() {
  const { ref: imgRef, isVisible: imgVisible } = useScrollAnimation();
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation();

  const highlights = [
    { icon: "ri-layout-grid-line", text: "Residential Layout Development" },
    { icon: "ri-home-2-line", text: "Villa Plot Projects" },
    { icon: "ri-leaf-line", text: "Eco-Friendly Planning" },
    { icon: "ri-shield-check-line", text: "Documentation" },
  ];

  return (
    <section id="about" className="bg-[#EAF5E1] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Image */}
          <div
            ref={imgRef as (el: HTMLDivElement | null) => void}
            className={`w-full lg:w-1/2 relative reveal ${imgVisible ? "visible" : ""}`}
          >
            <div className="rounded-2xl overflow-hidden h-[420px] md:h-[500px] img-zoom">
              <img
                src="https://readdy.ai/api/search-image?query=eco%20friendly%20residential%20layout%20development%20near%20Sarjapur%20Road%20Bangalore%2C%20green%20gated%20community%20with%20wide%20roads%20and%20trees%2C%20premium%20residential%20plots%20with%20lush%20greenery%2C%20aerial%20view%20of%20residential%20layout%20Bangalore%2C%20peaceful%20residential%20area%20with%20open%20spaces%20and%20greenery&width=800&height=700&seq=ui-about-home-01&orientation=portrait"
                alt="Urban Infra eco-friendly residential layouts on Sarjapur Road"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="absolute top-5 left-5 bg-white rounded-xl px-4 py-3 border border-[#7FBF3F]/20">
              <div className="text-xs text-gray-500 font-medium">Established</div>
              <div className="text-sm font-bold text-[#1B2A4A]" style={{ fontFamily: "'Playfair Display', serif" }}>Since 2016, Bengaluru</div>
            </div>
            <div className="absolute -bottom-5 -right-5 bg-[#1B2A4A] text-white rounded-2xl p-5 text-center">
              <div className="text-3xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>7+</div>
              <div className="text-[#7FBF3F] text-xs mt-0.5">Projects Delivered</div>
            </div>
          </div>

          {/* Content */}
          <div
            ref={contentRef as (el: HTMLDivElement | null) => void}
            className={`w-full lg:w-1/2 reveal reveal-delay-2 ${contentVisible ? "visible" : ""}`}
          >
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-white px-3 py-1.5 rounded-full mb-4 border border-[#7FBF3F]/20">
              About Urban Infra
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] leading-tight mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
              Building Eco-Friendly Communities On Sarjapur Road
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              URBAN INFRA is a Bengaluru-based real estate developer focused on creating eco-friendly communities in Bangalore. Since 2016, the company has delivered projects on Sarjapur Road with strong planning and infrastructure.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8" style={{ fontFamily: "'Poppins', sans-serif" }}>
              We focus on quality, transparency, and long-term customer relationships — combining natural living with modern infrastructure and long-term investment value.
            </p>

            <div className="grid grid-cols-2 gap-3 mb-8">
              {highlights.map((item) => (
                <div key={item.text} className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-[#7FBF3F]/15 transition-all duration-300 hover:border-[#7FBF3F]/40 hover:bg-[#EAF5E1]">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#EAF5E1] rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-[#7FBF3F] text-base`}></i>
                  </div>
                  <span className="text-sm font-medium text-[#212121]" style={{ fontFamily: "'Poppins', sans-serif" }}>{item.text}</span>
                </div>
              ))}
            </div>

            <a
              href="/about"
              className="btn-hover inline-flex items-center gap-2 bg-[#1B2A4A] hover:bg-[#243660] text-white font-semibold text-sm px-6 py-3 rounded-xl cursor-pointer whitespace-nowrap"
            >
              Know More About Us
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
